<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ service.name }}
        </h1>
        <h1>
          {{ $tc('models.country', 2) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs6 sm6 md6>
                    <v-checkbox
                      class="mb-4"
                      v-model="selectAll"
                      :label="selectAll ? $t('unselectAll') : $t('selectAll')"
                      color="primary"
                    ></v-checkbox>

                    <v-checkbox
                      v-for="country in countries"
                      :key="country.id"
                      class="ma-0"
                      v-model="selectedCountries"
                      :label="country.name"
                      :value="country.id"
                      color="primary"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Service from '@/client/service'
import Country from '@/client/country'

export default {

  props: {},

  data () {
    return {
      loading: false,
      countries: [],
      selectedCountries: [],
      service: '',
      selectAll: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    
    async fetch () {
      const id = this.$route.params.serviceId
      this.countries = await Country.all({
        order: `countries.name asc`,
        per_page: 2000
      })

      if (id) {
        this.service = await Service.findOne(id, { include: 'countries' })
        this.selectedCountries = this.service.countries.map(o => o.id)
      }
    },

    async submit () {
      this.loading = true
      if (this.selectedCountries.length < 1) {
        this.handleErr({message: this.$t('minimumCountryError')})
      }
      else {
        try {
          await this.service.addServiceCountries({country_ids: this.selectedCountries, id: this.service.id})
          this.setNotification({
            color: 'success',
            message: this.$t('successfullySavedNotification')
          })
          this.back()
        } catch (err) {
          this.handleErr(err)
        }
      }
      this.loading = false
    }
  },

  watch: {
    selectAll () {
      if (this.selectAll) {
        for (let i = 0; i < this.countries.length; ++i) {
          this.selectedCountries.push(this.countries[i].id)
        }
      }else {
        this.selectedCountries = []
      }
    }
  },

  async mounted () {
    await this.fetch()

    this.selectAll = (this.selectedCountries.length === this.countries.length)
  }
}
</script>
